module.exports = __webpack_public_path__ + "static/media/img1.844fc40e.jpeg";